import React, { Component } from 'react';
import { Container, Row, Col, Dropdown } from 'react-bootstrap';
import { connect } from 'react-redux';
import AppSpinner from '../AppSpinner/AppSpinner';
import apiUrl from '../../utils/apiUrl';
import {
	Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Line, ComposedChart
} from 'recharts';

const select = state => {
	return {
		token: state.auth.token
	};
};

class ConnectedDashboardRetentionComponent extends Component {

	constructor(props) {
		super(props);

		this.state = {
			isLoading: true,
			data: {},
			selectedData: { title: '', data: [], metrics: [] },
		}
	}

	async componentDidMount() {

		const { token } = this.props;
		const dataResponse = await fetch(`${apiUrl}/admin/dashboard/retention?token=${token}`);
		const dataJson = await dataResponse.json();

		if (dataJson.success) {
			this.setState({
				data: dataJson.data,
				selectedData: dataJson.data.userMetrics,
				isLoading: false
			});
		}

	}

	render() {

		const { isLoading, data, selectedData } = this.state;
		const {
			userMetrics,
			commerceMetrics,
			organizationMetrics,
			businessMetrics,
		} = data;

		const colors = ['#8884D8', '#83A6ED', '#8DD1E1', '#82CA9D', '#A4DE6C', '#D0ED57', '#FFC658'];

		if (isLoading) return (<AppSpinner />);

		return (
			<div className="foundations-component">
				<Container>

					<Row>
						<Col xs={12}>
							<h2 style={{ marginBottom: '25px' }}>Indices de Retención</h2>
						</Col>
						<Col xs={12}>
							<hr />
						</Col>
						<Col xs={12} style={{ textAlign: 'center' }}>
							<Dropdown>
								<Dropdown.Toggle variant="success" id="dropdown-basic">
									Seleccionar índice
								</Dropdown.Toggle>

								<Dropdown.Menu>
									<Dropdown.Item onClick={() => this.setState({ selectedData: userMetrics })} >
										Metricas de usuarios
									</Dropdown.Item>
									<Dropdown.Item onClick={() => this.setState({ selectedData: commerceMetrics })} >
										Metricas de comercios
									</Dropdown.Item>
									<Dropdown.Item onClick={() => this.setState({ selectedData: organizationMetrics })} >
										Metricas de organizaciones
									</Dropdown.Item>
									<Dropdown.Item onClick={() => this.setState({ selectedData: businessMetrics })} >
										Metricas de empresas
									</Dropdown.Item>
								</Dropdown.Menu>
							</Dropdown>
						</Col>

						<Col xs={12}><h6 style={{ marginBottom: '10px', fontWeight: '600' }}>{selectedData.title}</h6></Col>

						<Col xs={12}>
							<div style={{ width: '100%', height: 400 }}>
								<ResponsiveContainer>
									<ComposedChart
										width={500}
										height={300}
										data={selectedData.data}
										margin={{
											top: 20, right: 30, left: 20, bottom: 5,
										}}
									>
										<CartesianGrid strokeDasharray="3 3" />
										<XAxis dataKey="label" />
										<YAxis yAxisId="left" orientation="left" stroke="#8884D8" />
										<Tooltip />
										<Legend />
										{
											selectedData.metrics.map((metric, i) =>
												<Bar key={i} yAxisId="left" stackId="a" dataKey={metric} fill={colors[i]} />
											)
										}
										<Line type="monotone" yAxisId="left" dataKey="average" stroke="#ff7300" />
									</ComposedChart>
								</ResponsiveContainer>
							</div>
						</Col>
					</Row>

				</Container>
			</div>
		);
	}
}

const DashboardRetentionComponent = connect(select)(ConnectedDashboardRetentionComponent);

export default DashboardRetentionComponent;
